import { Component, OnInit } from '@angular/core';
import { BookService } from '../shared/book.service';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss']
})
export class DemoComponent implements OnInit {

  arrBook!: any[];

  constructor(private service: BookService) { }

  ngOnInit(): void {
    var booksOnline = this.service.getBooks();
    var products: any = (booksOnline as any).default;
    var listItem = [];
    for (const property in products) {
      listItem.push(products[property]);
    }
    this.arrBook = listItem.map((item) => {
      return {
        info: item.desc,
        code: item.code,
        category: item.label,
        background: `../../../assets/${item.code}/image/background_stretch.png`,
        url: `../../../assets/${item.code}/image/avatar.png`,
        routerLink: ['/demo/list-category'],
        queryParams: {
          code: item.code
        }
      };
    });
  }



}
